import { COMPLETE_ORDER_FEATURE } from '../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );
export const getActiveFormStepState = createSelector(
  getCompleteOrderState,
  (state) => state.activeFormStep
);

export const getActiveFormStep = createSelector(
  getActiveFormStepState,
  (state) => state.data
);
